import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { BsArrowLeft } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
//styles
import '../assets/css/backoffice/styleBackoffice.scss';
//components
import HeadIntranet from 'components/metatags_helmet/metatagsIntranet';
import AsideMenuIntranet from '../components/backoffice/asideMenuIntranet';
import Loader from 'components/backoffice/loader/backofficeLoader';
//context
import { useGlobalContext } from 'context/globalContext';
import LanguageSwitcher from 'components/navbar/LanguageSwitcher';
import { useLanguageReload } from 'context/languageReloadContext';

const AdminIntranetLayout = () => {
  const navigate = useNavigate();
  const { t: headerT } = useTranslation(['header']);
  const { contentLanguage } = useLanguageReload();
  const { t: backofficeT } = useTranslation(['backoffice']);
  const { t: librariesT } = useTranslation(['libraries']);

  const { isLoading } = useGlobalContext();
  const [title, setTitle] = useState('');

  const t = (key) => {
    if (headerT(key) !== key) {
      return headerT(key);
    }
    if (librariesT(key) !== key) {
      return librariesT(key);
    }
    return backofficeT(key);
  };

  const showBackButton = window.history.length > 1;
  return (
    <main className="pr-2 bg-dark">
      <HeadIntranet title={title} />
      <Row className="none-scroll m-0 w-100 d-flex ">
        <Col className="border-right px-0 aside-menu-column">
          <AsideMenuIntranet />
        </Col>
        <Loader isLoading={isLoading} />
        <Col className="border-left position-relative">
          <Row className="mt-4 mx-lg-4">
            <Col xs={6} lg={6} className="d-flex align-items-center justify-content-start">
              {showBackButton && (
                <BsArrowLeft
                  color="#69f853"
                  size="33"
                  onClick={() => navigate(-1)}
                  className="cursor-pointer"
                  title={t('back')}
                />
              )}
            </Col>
            <Col xs={6} lg={6} className="d-flex align-items-center justify-content-end">
              <LanguageSwitcher className="lang-select-desktop w-auto" />
            </Col>
          </Row>
          <Row className="container-outlet">
            <Col lg={12} className="mt-3 px-lg-5 px-3">
              <Outlet key={contentLanguage} context={{ setTitle }} />
            </Col>
          </Row>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="container-toastify"
      />
    </main>
  );
};

export default AdminIntranetLayout;